import {LiveFlightFragmentFragment} from "../../../../__generated__/graphql/types";
import {LiveFlightsRow} from "./types";
import {TableViewsContext} from "./table-views";
import moment from "moment";

export default function groupByContractView(dataSource: any[], context: TableViewsContext): LiveFlightsRow[] {

    // Flights grouped by contract
    const grouped = new Map<string, LiveFlightFragmentFragment[]>();

    dataSource.forEach((flight: LiveFlightFragmentFragment) => {
        const contract = flight.contract || null;
        if (!grouped.has(contract?._id)) {
            grouped.set(contract?._id, [flight] as LiveFlightsRow[]);
        }
        else {
            grouped.get(contract?._id)?.push(flight);
        }
    })

    const result: LiveFlightsRow[] = [];

    grouped.forEach((flights, _) => {

        // Sort in reverse order so we can find the latest flight before current time
        const sortedFlights = flights.sort((a, b) => a.estDepartureTime < b.estDepartureTime? 1 : -1)

        for (let i = 0; i < sortedFlights.length; i++) {
            const flight = sortedFlights[i];
            const departTime = flight.estDepartureTime ? moment(flight.estDepartureTime, 'HH:mm') : null;

            const children = [...sortedFlights.slice(0, i), ...sortedFlights.slice(i+1, sortedFlights.length)];

            if (departTime?.isSameOrBefore(context.currentTime)){
                result.push({
                    ...sortedFlights[i],
                    children: children.length ? children : undefined
                });
                return result;
            }
        }

        const children = sortedFlights.slice(1, sortedFlights.length);

        result.push({
            ...sortedFlights[0],
            children: children.length ? children : undefined
        });
    })

    return result;
}